import { BrowseByTagsType } from 'common/events/ClientEvents';
import { chain, snakeCase } from 'lodash';
import { CuisineRegion } from 'src/gqlReactTypings.generated.d';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { Category } from './types';

const imgUrlPrefix = 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/explore/cuisines/koto';

export const getCategoryLabel = (cuisine: string) => chain(cuisine).lowerCase().startCase().value();
function generateCategory(cuisine: CuisineRegion): Category {
  return {
    tagType: BrowseByTagsType.CUISINE,
    value: cuisine,
    image: `${imgUrlPrefix}/${snakeCase(cuisine)}.jpg`,
    label: getCategoryLabel(cuisine),
  };
}

function generateDietary(tag: DietaryTags): Category {
  return {
    tagType: BrowseByTagsType.DIETARY_PREFERENCE,
    value: tag,
    image: `${imgUrlPrefix}/${snakeCase(tag)}.jpg`,
    label: chain(tag).lowerCase().startCase().value(),
  };
}

/**
 * Hard coded cuisine categories... they should not be hard coded if extending this
 * in the future.
 */
export const defaultCategories: Category[] = [
  generateCategory(CuisineRegion.Indian),
  generateCategory(CuisineRegion.Chinese),
  generateCategory(CuisineRegion.SoutheastAsian),
  generateCategory(CuisineRegion.American),
];

const categoriesByRegion = new Map<number, Category[]>();

// NEW_YORK
categoriesByRegion.set(2, [
  generateCategory(CuisineRegion.Indian),
  generateDietary(DietaryTags.HALAL),
  generateCategory(CuisineRegion.SoutheastAsian),
  generateCategory(CuisineRegion.American),
]);

export default function getCategories(regionId: number): Category[] {
  return categoriesByRegion.get(regionId) ?? defaultCategories;
}
